class productsSlider extends HTMLElement {
  constructor() {
    super();
    this.swiperCarousel();
  }

  swiperCarousel() {
    var slider = new Swiper(".products-slider__swiper", {
      loop: true,
      effect: "slide",
      speed: 800,
      slidesPerView: 2,
      spaceBetween: 18,
      autoplay: {
        delay: 3000, 
        disableOnInteraction: false, 
      },
      breakpoints: {
        768: {
          slidesPerView: 4,
          spaceBetween: 47
        },
      },
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
    });
  }
}

customElements.define('products-slider', productsSlider);